
export const API_URL = 'https://api.doctorita.co.il/v1/'
export const BASE_URL = 'https://api.doctorita.co.il'
export const APP_URL = 'https://landing.doctorita.co.il/'